// @flow @jsx h

import { h, Component } from 'preact'
import { SerumResponsivePicture, HtmlContent } from '@nrk/dh-feature-components'

import styles from './index.css'
import { connect } from '../../../../../lib/provider'

type Props = {
  intro: string,
  linkText: string,
  title: string,
  text: string,
  imageId: string,
  sendGaEvent: (Object) => void
}

type ContextProps = {
  sendGaEvent?: any => void
}

type State = {
  expanded: boolean
}

class _Person extends Component<Props & ContextProps, State> {
  constructor () {
    super()
    this.state = {
      expanded: false
    }
  }

  handleToggle = (event: Event) => {
    event.preventDefault()
    this.setState({ expanded: !this.state.expanded })

    this.props.sendGaEvent &&
    this.props.sendGaEvent({
      action: this.state.expanded ? 'SHOW_PERSON_DETAILS' : 'HIDE_PERSON_DETAILS',
      label: this.props.title
    })
  }

  render () {
    const { intro, linkText, title, text, imageId } = this.props
    const { expanded } = this.state

    const [introStart, introEnd] = intro.split(linkText)

    return <div>
      <p key='1' class={styles.personIntro}>
        {introStart}
        <a
          href='https://nrk.no'
          role='button'
          aria-expanded={expanded.toString()}
          onClick={this.handleToggle}>
          <HtmlContent element={'p'} content={linkText.replace(' ', '&nbsp;')} />
          <svg focusable='false' aria-hidden='true'>
            <use xlinkHref='#nrk-close-circle' />
          </svg>
        </a>
        {introEnd}
      </p>
      {expanded && (
        <aside key='2' class={styles.person}>
          <div className={styles.person__content}>
            <a
              href='https://nrk.no'
              role='button'
              aria-expanded={expanded.toString()}
              onClick={this.handleToggle}>
              <svg focusable='false' aria-hidden='true'>
                <use xlinkHref='#nrk-close-circle' />
              </svg>
            </a>
            <h3>{title}</h3>
            <SerumResponsivePicture
              className={styles.person__image}
              id={imageId}
              alt=''
              ratio={'3:4'}
              sizes='(min-width: 520px) 150px, 200px'
            />
            <HtmlContent element={'p'} content={text} />
          </div>
        </aside>
      )}
    </div>
  }
}

const connector = connect()
// const connector = connect(mapContextToProps)
export const Person = connector(_Person)
